import { Box, Typography } from '@mui/material';

import CpdBundleHaveCourseTag from '../cpdBundleHaveCourseTag';
import InstructorCourseCardOnBundle from '../instructorCourseCardOnBundle';

import { CourseCardPaper } from './style';

import Image from 'src/components/atoms/image';
import CourseCardCertificateRibbon from 'src/components/molecules/courseCardCertificateRibbon';
import config from 'src/config';
import { useMediaQueryDevice } from 'src/helpers/use';
import { IInstructorsInfo } from 'src/interfaces';

type Props = {
  courseNo: number;
  courseImage: string;
  courseName: string;
  isEnrolled: boolean;
  haveCertificate: boolean;
  instructors: IInstructorsInfo[] | [];
  isCPD?: boolean;
};

const CourseCardOnBundle = ({
  courseNo,
  courseImage,
  courseName,
  isEnrolled,
  haveCertificate,
  instructors,
  isCPD = false,
}: Props) => {
  const { matchesMobile } = useMediaQueryDevice();

  return (
    <CourseCardPaper>
      <Box className="course-card-detail-box">
        <Box className="course-card-image-box">
          <Box className="course-card-no-box">
            <Typography
              lineHeight="22px"
              variant="h6_deprecated"
              fontWeight={500}
              fontStyle="normal"
              color="rgba(0, 0, 0, 0.6)"
            >
              คอร์ส
            </Typography>
            <Typography
              lineHeight="43px"
              fontSize="64px"
              fontWeight={400}
              fontStyle="normal"
              color="rgba(0, 0, 0, 0.6)"
            >
              {courseNo}
            </Typography>
          </Box>
          <Image
            className="image"
            style={{ borderRadius: '10px' }}
            src={courseImage}
            errorImage={`${config.IMAGE_CDN_HOST}/assets/thumbnail-course-card.jpg`}
            alt={courseName}
          />
        </Box>
        <Box className="course-card-info-box">
          <Typography className="text-info-header">คอร์สออนไลน์</Typography>
          <Typography className="text-info-course-name">{courseName}</Typography>
          <Box className="course-card-instructors-info-box">
            {instructors[0] && <InstructorCourseCardOnBundle instructor={instructors[0]} />}
            {instructors[1] && !matchesMobile && <InstructorCourseCardOnBundle instructor={instructors[1]} />}
          </Box>
          {isEnrolled && <CpdBundleHaveCourseTag isCPD={isCPD} />}
        </Box>
      </Box>
      <Box className="ribbon-certificate-box">{haveCertificate && <CourseCardCertificateRibbon />}</Box>
    </CourseCardPaper>
  );
};

export default CourseCardOnBundle;
